export const environment = {
    production: false,
    apiBaseUrl: 'https://al-app-int-itemregistry-preprod.azurewebsites.net/api/v1/',
    apiBaseUrlv2: 'https://al-app-int-itemregistry-preprod.azurewebsites.net/api/v2/',
    adminToolClientId: 'a3943031-3465-4563-a77e-1988ecd69b99',
    adminToolTenentId: 'ed5d5f47-52dd-48af-90ca-f7bd83624eb9',
    appRegScope: 'api://al-sp-integration-item-registry-nonprod/access_as_user',
    env: 'preprod',
};
